import script from "./leftPie2.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie2.vue?vue&type=script&setup=true&lang=js"

import "./leftPie2.vue?vue&type=style&index=0&id=bac091ca&scoped=true&lang=css"
script.__scopeId = "data-v-bac091ca"

export default script